import React from 'react'
import { Link } from 'gatsby'
import Container from 'components/container.js'
import logo from 'svgs/logo-akai-red.svg'
import { css, useTheme } from '@emotion/react'
import Socials from 'components/socials'
import EmailSignup from 'components/email-signup'
import accountIcon from 'svgs/account-icon-black.svg'
// import USIcon from 'svgs/united-states-flag-icon.svg'
import mpcstoreLogo from 'svgs/mpc-store.svg'
import inmusicLogoBlack from 'svgs/inmusic-logo-black.svg'
import paths from 'data/paths.json'
import ExternalLink from './external-link'
import bg from 'images/subscribe-bg.png'

const column = theme => css({
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    '& h6': {
        fontSize: 12,
        fontWeight: 600,
        color: theme.colors.black,
        fontStyle: 'normal',
        lineHeight: '100%',
    },
})

export const InMusic = (props) => {
    const { mobile } = props
    return(
        <Container id='inmusic' fluid css={{ backgroundColor: '#C2C2C2' }} {...props}>
            <Container>
                <div className='d-flex f-column' css={{
                    gap: mobile ? 20 : 48,
                    padding: mobile ? 20 : '40px 120px',
                    '@media(max-width: 768px)': { padding: mobile ? 20 : '40px 40px', },
                    '@media(max-width: 576px)': { padding: mobile ? 20 : '40px 16px', },
                }}>
                    {/* INMUSIC LOGO + LINE */}
                    <div className='d-flex a-center' css={{ gap: 24 }}>
                        <a href={paths.external.inmusic} target="_blank" rel="noreferrer">
                            <img src={inmusicLogoBlack} alt='inmusic logo black' height={32} />
                        </a>
                        <div style={{
                            height: 1,
                            flexGrow: 1,
                            backgroundColor: 'black',
                            transform: 'scaleY(0.5)', // half pixel
                        }} />
                    </div>

                    {/* COPYRIGHT | LINKS | PART OF... */}
                    <div className='d-flex j-between' css={{
                        '@media(max-width: 1024px)': {
                            flexDirection: 'column',
                            gap: 20,
                        }
                    }}>
                        <div className='d-flex f-wrap' css={{ alignItems: 'baseline', gap: 4, }}>
                            <p className='xs black f-secondary'>
                                © {new Date().getFullYear()} inMusic, LLC. All Rights Reserved.
                            </p>
    
                            <div className='black'>
                                <Link to={paths.root.company.dealers.path}>
                                    Dealers
                                </Link>
                                &nbsp;|&nbsp;
                                <a href={paths.external.support} target="_blank" rel="noreferrer">
                                    Support
                                </a>
                                &nbsp;|&nbsp;
                                <a href={paths.external.careers} target="_blank" rel="noreferrer">
                                    Careers
                                </a>
                                &nbsp;|&nbsp;
                                <Link to={paths.root.privacy.path}>
                                    Privacy
                                </Link>
                                &nbsp;|&nbsp;
                                <Link to={paths.root.termsOfUse.path}>
                                    Terms of Use
                                </Link>
                                &nbsp;|&nbsp;
                                <div id="teconsent" className='d-inline-block xs black td-none h-underline' />
                            </div>
                        </div>

                        <p className='sm bold black'>
                            Part of the inMusic family of brands
                        </p>
                    </div>
                </div>
            </Container>
        </Container>
    )
}

export default function Footer() {
    const theme = useTheme()
    return <footer id='footer'>
        {/* MAIN LINKS */}
        <Container fluid style={{ backgroundColor: '#DBDBDB' }}>
            <Container>
                <div css={{
                    padding: '40px 120px 80px',
                    '@media(max-width: 768px)': {
                        padding: '40px 40px',
                    },
                    '@media(max-width: 576px)': {
                        padding: '40px 16px',
                    },
                }}>
                    {/* LOGO & SOCIALS */}
                    <div css={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 20,
                        '@media(max-width: 375px)': {
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }
                    }}>
                        <Link to={paths.root.path}>
                            <img src={logo} alt='' />
                        </Link>
                        <Socials />
                    </div>

                    {/* LINKS */}
                    <div css={{
                        display: 'grid',
                        gap: 20,
                        marginTop: 80,
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        '@media(max-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)', gap: 40, marginTop: 40, },
                        '@media(max-width: 350px)': { gap: 20, marginTop: 20, }
                    }}>
                        <div css={column}>
                            <p className='xs black fw-600'>Products</p>
                            <Link to={paths.root.products.collections.mpc.path}>
                                MPC Series
                            </Link>
                            <Link to={paths.root.products.controllers.midi_keyboard.path}>
                                Keyboards
                            </Link>
                            <Link to={paths.root.products.controllers.path}>
                                Controllers
                            </Link>
                            <Link to={paths.root.soundsAndSoftware.path}>
                                Software
                            </Link>
                        </div>
    
                        <div css={column}>
                            <p className='xs black fw-600'>Company</p>
                            <Link to={paths.root.company.aboutUs.path}>
                                About Us
                            </Link>
                            <Link to={paths.root.company.dealers.path}>
                                Dealers
                            </Link>
                        </div>
    
                        <div css={column}>
                            <p className='xs black fw-600'>Support</p>
                            <Link to={paths.root.downloadsAndSupport.downloads.path}>
                                Downloads
                            </Link>
                            <ExternalLink href={paths.external.support}>
                                Contact Us
                            </ExternalLink>
                            <Link to={paths.root.downloadsAndSupport.support.repairs.path}>
                                Repairs
                            </Link>
                        </div>
                        
                        <div css={column}>
                            <p className='xs black fw-600'>Account</p>
                            <a
                                href={paths.external.login}
                                target='_blank'
                                rel='noreferrer'
                                className='d-flex a-center g-1'
                                css={{ padding: 12, border:`1px solid ${theme.colors.black}` }}
                            >
                                <img src={accountIcon} alt='' height={16} width={16} />
                                Login
                            </a>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>

        {/* MPC STORE */}
        <Container fluid style={{ backgroundColor: theme.colors.mpc }}>
            <Container>
                <div css={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '12px 120px',
                    gap: 20,
                    '@media(max-width: 768px)': {
                        padding: '12px 40px',
                    },
                    '@media(max-width: 576px)': {
                        gap: 24,
                        padding: 12,
                        flexDirection: 'column',
                    },
                }}>
                    <a href={paths.external.thempcstore} target='_blank' rel='noreferrer'>
                        <img src={mpcstoreLogo} alt='MPC Store' height={18} />
                    </a>
                    <p css={{
                        fontSize: 12,
                        fontWeight: 400,
                        color: 'white',
                        fontStyle: 'normal',
                        lineHeight: '18px',
                        textWrapStyle: 'balance',
                        textAlign: 'right',
                        '@media(max-width: 576px)': {
                            textAlign: 'left',
                        },
                    }}>
                        Looking for <strong css={{ color: 'white', }}>Software</strong>?
                        Find Effects, Expansions, Instruments and Presets at&nbsp;
                        <a
                            href={paths.external.thempcstore}
                            target='_blank'
                            rel='noreferrer'
                            style={{
                                color: 'white',
                            }}
                            css={{
                                fontSize: 14,
                                fontStyle: 'normal',
                                fontWeight: 700,
                                lineHeight: '20px',
                                // textTransform: 'uppercase',
                                textDecoration: 'none',
                            }}
                        >
                            thempcstore.com
                        </a>
                    </p>
                </div>
            </Container>
        </Container>

        <InMusic />
    </footer>
}
